<template>
    <div style="margin-top: 10px;margin-left: 30px;">
        <el-card shadow="hover" style="box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);">
            <div slot="header" class="clearfix">
                <span>修改密码</span>
            </div>
            <el-form :model="passwordForm" :rules="rules" ref="passwordForm" label-width="100px">
                <el-form-item label="原密码" prop="oldPassword">
                    <el-input 
                        v-model="passwordForm.oldPassword" 
                        placeholder="请输入原密码"
                        :type="showOldPassword ? 'text' : 'password'"
                        style="width: 300px"
                    >
                        <i slot="suffix" 
                            class="el-icon-view" 
                            @click="showOldPassword = !showOldPassword"
                            style="cursor: pointer; margin-right: 10px;"
                        ></i>
                    </el-input>
                </el-form-item>
                <el-form-item label="新密码" prop="newPassword">
                    <el-input 
                        v-model="passwordForm.newPassword" 
                        placeholder="请输入新密码"
                        :type="showNewPassword ? 'text' : 'password'"
                        style="width: 300px"
                    >
                        <i slot="suffix" 
                            class="el-icon-view" 
                            @click="showNewPassword = !showNewPassword"
                            style="cursor: pointer; margin-right: 10px;"
                        ></i>
                    </el-input>
                </el-form-item>
                <el-form-item label="确认密码" prop="confirmPassword">
                    <el-input 
                        v-model="passwordForm.confirmPassword" 
                        placeholder="请再次输入新密码"
                        :type="showConfirmPassword ? 'text' : 'password'"
                        style="width: 300px"
                    >
                        <i slot="suffix" 
                            class="el-icon-view" 
                            @click="showConfirmPassword = !showConfirmPassword"
                            style="cursor: pointer; margin-right: 10px;"
                        ></i>
                    </el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="submitForm">修改密码</el-button>
                    <el-button @click="resetForm">重置</el-button>
                </el-form-item>
            </el-form>
        </el-card>
    </div>
</template>

<script>
export default {
    name: "Password",
    data() {
        const validatePass = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请再次输入密码'));
            } else if (value !== this.passwordForm.newPassword) {
                callback(new Error('两次输入密码不一致!'));
            } else {
                callback();
            }
        };

        const validateNewPassword = (rule, value, callback) => {
            if (value === this.passwordForm.oldPassword) {
                callback(new Error('新密码不能与原密码相同'));
            } else {
                callback();
            }
        };

        return {
            showOldPassword: false,
            showNewPassword: false,
            showConfirmPassword: false,
            passwordForm: {
                oldPassword: '',
                newPassword: '',
                confirmPassword: ''
            },
            inputWidth: '300px', // 可自定义的输入框宽度
            rules: {
                oldPassword: [
                    { required: true, message: '请输入原密码', trigger: 'blur' }
                ],
                newPassword: [
                    { required: true, message: '请输入新密码', trigger: 'blur' },
                    { min: 6, max: 20, message: '长度在 6 到 20 个字符', trigger: 'blur' },
                    { validator: validateNewPassword, trigger: 'blur' }
                ],
                confirmPassword: [
                    { required: true, validator: validatePass, trigger: 'blur' }
                ]
            }
        };
    },
    methods: {
        async submitForm() {
            try {
                const response = await this.$axios.post('/web/company/user/checkPassWord', {
                    oldPassWord: this.passwordForm.oldPassword
                });

                if (response.data.status === 200) {
                    const updatePassWordresponse = await this.$axios.post('/web/company/user/updatePassWord', {
                        newPassWord: this.passwordForm.newPassword
                    });
                    if (updatePassWordresponse.status === 200) {
                        this.$confirm('密码修改成功，请重新登录', '提示', {
                            confirmButtonText: '确定',
                            showCancelButton: false,
                            type: 'success'
                        }).then(() => {
                            this.$store.dispatch('logout');
                            this.$router.push('/login');
                        });
                    }
                } else {
                    this.$message.error('原密码不正确');

                }

            } catch (error) {
                this.$message.error('密码修改失败');

            }


        },
        resetForm() {
            this.$refs.passwordForm.resetFields();
        }
    }
};
</script>

<style scoped>
.password-container {
    padding: 20px;
    width: 90%;
}

.password-card {
    width: 100%;
    margin: 0 auto;
}

.el-form-item__content {
    text-align: left;
}
</style>